import dayjs from 'dayjs'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import weekOfYear from 'dayjs/plugin/weekOfYear'

dayjs.extend(quarterOfYear)
dayjs.extend(weekOfYear)

export const QUICK_DATE_OPTIONS = [
  { value: 'Day', label: 'Day' },
  { value: 'WTD', label: 'WTD' },
  { value: 'MTD', label: 'MTD' },
  { value: 'QTD', label: 'QTD' },
  { value: 'YTD', label: 'YTD' },
  { value: 'One Year', label: '1 Year' },
  { value: 'Two Year', label: '2 Year' },
  { value: 'Three Year', label: '3 Year' },
  { value: 'Four Year', label: '4 Year' },
  { value: 'Five Year', label: '5 Year' },
  { value: 'Six Year', label: '6 Year' },
  { value: 'Seven Year', label: '7 Year' },
  { value: 'Eight Year', label: '8 Year' },
  { value: 'Nine Year', label: '9 Year' },
  { value: 'Ten Year', label: '10 Year' },
  { value: 'Previous 1-Year', label: 'Prev 1 Year' },
  { value: 'Previous 2-Year', label: 'Prev 2 Year' },
  { value: 'Previous 3-Year', label: 'Prev 3 Year' },
  { value: 'Previous 5-Year', label: 'Prev 5 Year' },
  { value: 'Inception', label: 'Inception' },
  { value: 'Holding Period', label: 'Holding Period' },
  { value: 'Custom', label: 'Custom Range...' }
]

const DATE_FMT = 'YYYY-MM-DD'

const YEAR_MAP = {
  'One Year': 1,
  'Two Year': 2,
  'Three Year': 3,
  'Four Year': 4,
  'Five Year': 5,
  'Six Year': 6,
  'Seven Year': 7,
  'Eight Year': 8,
  'Nine Year': 9,
  'Ten Year': 10
}

const PREV_YEAR_MAP = {
  'Previous 1-Year': 1,
  'Previous 2-Year': 2,
  'Previous 3-Year': 3,
  'Previous 5-Year': 5
}

export function resolveQuickDate (token, asOfDate) {
  const ref = asOfDate ? dayjs(asOfDate) : dayjs()
  const end = ref.format(DATE_FMT)

  if (token === 'Day') {
    return { startDate: end, endDate: end }
  }

  if (token === 'WTD') {
    return { startDate: ref.startOf('week').format(DATE_FMT), endDate: end }
  }

  if (token === 'MTD') {
    return { startDate: ref.startOf('month').format(DATE_FMT), endDate: end }
  }

  if (token === 'QTD') {
    return { startDate: ref.startOf('quarter').format(DATE_FMT), endDate: end }
  }

  if (token === 'YTD') {
    return { startDate: ref.startOf('year').format(DATE_FMT), endDate: end }
  }

  if (YEAR_MAP[token]) {
    return {
      startDate: ref.subtract(YEAR_MAP[token], 'year').format(DATE_FMT),
      endDate: end
    }
  }

  if (PREV_YEAR_MAP[token]) {
    const years = PREV_YEAR_MAP[token]
    const prevYearEnd = ref.subtract(1, 'year').endOf('year')
    return {
      startDate: prevYearEnd.subtract(years, 'year').add(1, 'day').format(DATE_FMT),
      endDate: prevYearEnd.format(DATE_FMT)
    }
  }

  if (token === 'Inception') {
    return { startDate: '1900-01-01', endDate: end }
  }

  // Placeholder: resolves the same as Inception until position-level
  // inception dates are available to compute actual holding period start.
  if (token === 'Holding Period') {
    return { startDate: '1900-01-01', endDate: end }
  }

  return null
}
